import { InternalServerError } from 'common/errors'

export default function handleGraphQLError(error: any) {
  if (error) {
    return new error()
  } else {
    return new InternalServerError()
  }
}
